import type { CompositionV3Ent } from '@revelio/data-access';

export const areRequestedEntitiesEqual = (
  previous: readonly CompositionV3Ent[],
  next: readonly CompositionV3Ent[]
): boolean =>
  previous.length === next.length &&
  previous.every(
    (ent, index) =>
      ent.EntID === next[index]?.EntID && ent.EntType === next[index]?.EntType
  );

export const areEntityNameMapsEqual = (
  previous: ReadonlyMap<string, string> | undefined,
  next: ReadonlyMap<string, string> | undefined
): boolean => {
  if (previous === undefined || next === undefined) {
    return previous === next;
  }
  if (previous.size !== next.size) {
    return false;
  }
  for (const [key, name] of previous) {
    if (!next.has(key) || next.get(key) !== name) {
      return false;
    }
  }
  return true;
};
